module.exports = __webpack_public_path__ + "img/amex.ca9781b8.svg";